const actionTypes = {
  FetchReservation: 'FETCH_RSERVATION',
  UpdateReservation: 'UPDATE_RESERVATION',
};

export default actionTypes;
